import api from "./index";

/**
 * Get garden groups
 * @returns {Promise<Array>}
 */
export async function getGardenGroups() {
    const res =
        await api.get(
            "/groups"
        );

    return (
        res.data?.groups ??
        []
    );
}

/**
 * Create garden group
 * @param {string} group_name
 * @param {number[]} garden_ids
 */
export async function createGardenGroup(user_id, group_name, garden_ids = []) {
    const res = await api.post("/groups", { user_id, group_name, garden_ids });
    return res.data;
}

/**
 * Update garden group
 * @param {number} group_id
 * @param {{
 *   group_name?: string,
 *   garden_ids?: number[]
 * }} updates
 */
export async function updateGardenGroup(
    group_id,
    updates
) {
    const res =
        await api.put(
            `/groups/${group_id}`,
            updates
        );

    return res.data;
}

/**
 * Delete garden group
 * @param {number} group_id
 */
export async function deleteGardenGroup(
    group_id
) {
    const res =
        await api.delete(
            `/groups/${group_id}`
        );

    return res.data;
}